"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DividerLineType = exports.ReactLineStyle = void 0;
var ReactLineStyle;
(function (ReactLineStyle) {
    ReactLineStyle["DEFAULT"] = "default";
    ReactLineStyle["ACCENT"] = "accent";
    ReactLineStyle["LIGHT"] = "light";
    ReactLineStyle["MEDIUM"] = "medium";
})(ReactLineStyle || (exports.ReactLineStyle = ReactLineStyle = {}));
var DividerLineType;
(function (DividerLineType) {
    DividerLineType["SINGLE"] = "single";
    DividerLineType["DOTTED"] = "dotted";
    DividerLineType["DOUBLE"] = "double";
})(DividerLineType || (exports.DividerLineType = DividerLineType = {}));
//# sourceMappingURL=CommonTypes.js.map